import { mutatorAction } from 'satcheljs';
import { getGroupFolder } from '../selectors/getGroupFolder';

export default mutatorAction(
    'moveFolderToDestFolder',
    (groupId: string, folderId: string, destFolderId: string) => {
        let destFolder = getGroupFolder(groupId, destFolderId);
        let folderToMove = getGroupFolder(groupId, folderId);

        if (folderToMove && destFolder) {
            // Add the folder to childfolders of destfolder
            let childFolderIds = destFolder.ChildFolderIds;

            if (!childFolderIds.includes(folderId)) {
                childFolderIds.push(folderId);
                destFolder.ChildFolderCount++;
            }

            // Update the parentfolder of the folder to be destfolder
            folderToMove.ParentFolderId = destFolderId;
        }
    }
);
